import validate from "/app/node_modules/.pnpm/nuxt@4.3.1_@vue+compiler-sfc@3.5.28_eslint@9.39.3_tsx@4.21.0_typescript@5.9.3_vite@7.3.1/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.3.1_@vue+compiler-sfc@3.5.28_eslint@9.39.3_tsx@4.21.0_typescript@5.9.3_vite@7.3.1/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}